import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { Hero } from "@/components/Hero";
import { Pillars } from "@/components/Pillars";
import { Domains } from "@/components/Domains";
import { TFM } from "@/components/TFM";
import { WhyNomas } from "@/components/WhyNomas";
import { Impact } from "@/components/Impact";
import { Contact } from "@/components/Contact";
import { scrollToSection } from "@/lib/scroll";

const Preloader = () => (
    <motion.div
        exit={{ y: "-100%" }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        className="fixed inset-0 z-[100] flex w-full max-w-[100vw] flex-col items-center justify-center overflow-hidden bg-[#0E1112] px-6"
        data-testid="preloader"
    >
        <div className="overflow-hidden">
            <motion.p
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                className="font-display text-3xl font-light tracking-[0.2em] text-[#F4F6F4] sm:text-4xl md:text-5xl md:tracking-[0.28em]"
            >
                NOM<span className="text-[#7CBF52]">A</span>S
            </motion.p>
        </div>
        <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.2, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
            className="mt-6 h-px w-40 origin-left bg-[#7CBF52]"
        />
        <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.6 }}
            className="mt-5 w-full max-w-full text-center text-[9px] uppercase leading-loose tracking-[0.18em] text-[#6B7A66] sm:tracking-[0.28em] md:text-[10px] md:tracking-[0.45em]"
        >
            Environment &middot; Trading &middot; Technology &middot; Consultancy
        </motion.p>
    </motion.div>
);

export default function HomePage() {
    const reduced = useReducedMotion();
    const location = useLocation();
    const [loading, setLoading] = useState(
        () => !sessionStorage.getItem("nomas_seen"),
    );

    useEffect(() => {
        sessionStorage.setItem("nomas_seen", "1");
        if (!loading) return;
        const t = setTimeout(() => setLoading(false), reduced ? 300 : 1900);
        return () => clearTimeout(t);
    }, [loading, reduced]);

    useEffect(() => {
        if (location.state?.scrollTo && !loading) {
            const h = location.state.scrollTo;
            const t = setTimeout(() => scrollToSection(h), 500);
            window.history.replaceState({}, "");
            return () => clearTimeout(t);
        }
    }, [location.state, loading]);

    return (
        <>
            <AnimatePresence>{loading && <Preloader />}</AnimatePresence>
            {!loading && <Hero />}
            <Pillars />
            <Domains />
            <TFM />
            <WhyNomas />
            <Impact />
            <Contact />
        </>
    );
}
